exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__payment-card-name___2eUpx{position:relative;color:#ecf0f1;z-index:10;font-family:OCR A Std;text-transform:uppercase;text-shadow:0 1px 3px rgba(44,62,80,.7);margin-left:1.3rem;margin-top:.5rem;font-size:14px}", ""]);

// exports
exports.locals = {
	"payment-card-name": "styles__payment-card-name___2eUpx"
};